module.exports = __webpack_public_path__ + "static/media/xenith-logo.ad6e1866.png";